  <script>
  export default {

    props : {
        title:{
          type:String,
          default: "",
      },
      info:{
          type:Object,
          default: null,
      }

    },
  methods: {

  },

  };


  </script>

<template>
    <div v-if="info.turnover" class="mt-4 p-3 bg-white" style="border:1px solid #ddd; border-radius:5px;">

      
      
      <div class="row" >

        <div class="col-12">
          <h5 class="text-dark font-size-12 font-weight-bold">{{title}} {{ info && info.lineAmountPoint && info.lineAmountPoint.length ? 'Palier des Remises' : '' }} </h5>
          <h5 v-if="info.turnover" class="text-dark font-size-12">Vous avez réalisé un <span class="font-weight-bold"> CA mensuel de {{ info.turnover }}.</span>          
          
            <span v-if="info.amountToNext" class="ml-2 text-danger font-size-14">  Il vous <span class="font-weight-bold ">reste {{ info.amountToNext }}</span> pour passer au palier suivant !</span>
          
          </h5>
        </div>

      </div>

      <div v-if="info && info.lineAmountPoint && info.lineAmountPoint.length" class="row mt-3"  >  
          <div v-for="index in info.lineAmountPoint.length" :key="index" class="pr-0"  :class=" info.lineAmountPoint.length <= 4 ? 'col-3' : 'col-2' ">
            <div v-if="info.lineAmountPoint[index-1]">
                <h5 class="text-left  font-weight-bold" style="font-size:12px;" :class=" !info.lineDiscountPoint[index-1] ? 'text-white' : ( info.lineTurnoverPercent[index-1] > 0 ? 'text-dark' : 'text-danger')">    <span class="d-none d-md-inline">{{ info.lineDiscountPoint[index-1] ? 'Remise ' : ''}}</span>     {{ info.lineDiscountPoint[index-1] ? '' + info.lineDiscountPoint[index-1] + '%' : '\u200B'}} </h5>
              
                <div class="text-center font-weight-bold" style="height:5px; width:100%; border-radius:0px; border-left: 3px solid #2a2c74;" :style="`background:linear-gradient(to right, #20c997 0%, #20c997 ${info.lineTurnoverPercent[index-1]}%, #eaeaea ${info.lineTurnoverPercent[index-1]}%, #eaeaea 100%)`">
                  <!-- <span v-if="info.lineTurnoverPercent[index-1] != 0 & info.lineTurnoverPercent[index-1] !=100" class="text-dark text-center d-none d-md-flex ">{{ info.turnover }}</span> -->
                </div>
                <h5 class="text-left font-weight-bold pt-3" style="font-size:12px" :class="info.lineTurnoverPercent[index-1] > 0 ? 'text-info' : 'text-secondary'">{{info.lineAmountPoint[index-1]}}</h5>
            </div>
        
          </div>
      </div>
    </div>
  </template>
